import { useQuery } from "@tanstack/react-query";
import { getCookieValue } from "../utils/getCookieValue";

const fetchProductCategories = (params = {}) => {
    return fetch(route("order.productCategories", params), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
            "X-Requested-With": "XMLHttpRequest",
        },
    }).then((response) => response.json());
};

export function useGetProductCategories(params = {}, options) {
    return useQuery({
        queryKey: ["products", "categories", params],
        queryFn: async () => {
            const response = await fetchProductCategories(params)
            if (options.onSuccess) {
                options.onSuccess(response);
            }
            return response;
        },
        ...options
    });
}
